    <div class="inner-router-wrapper">
        <div class="header-with-cta">
            <div class="dash-header">
                <div class="list">
                    <div class="title-dialog">
                        <p>Terms</p>

                        <mat-icon class="close" (click)="dialogRef.close()">close</mat-icon>
                    </div>
                    <!-- <div class="cta">
                        <button pButton type="button"  class="btn-general next-btn"
                        *ifClaim="'Employee_EditSignature'"
                         (click)="Resign()"
                                label="{{translation['EditSign']}}"></button>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="dialog-body">
            <!-- <div class="sign-available" *ngIf="signAvailable">
                <img src="{{signAvailable}}" alt="">
            </div> -->
            <!-- <div class="input-group p-col agree-all">
                <p-checkbox class="cust-checkbox" name="group1" value="active" (onChange)="agreeAll($event)"
                    label="{{translation['AgreeAll']}}" binary="true"></p-checkbox>
            </div> -->
            <table>
                <tr *ngFor="let item of terms; let i = index">
                    <!-- <td>
                        <p-checkbox class="cust-checkbox" name="group1" value="termsCompleted" [(ngModel)]="fields[i]"
                            binary="true"></p-checkbox>
                    </td> -->
                    <td>
                        <div class="item">
                            <p>
                                <!-- <span>{{i+1}} .</span> -->
                                {{item['TermsDescription']}}
                            </p>
                            <div class="children" *ngIf="item['Children'].length">
                                <ul>
                                    <li *ngFor="let child of item['Children']">
                                        {{child['TermsDescription']}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="item rtl">
                            <!-- <span>{{i+1}} .</span> -->
                            <p>{{item['TermsDescriptionOtherLanguage']}}</p>
                            <div class="children" *ngIf="item['Children'].length">
                                <ul>
                                    <li *ngFor="let child of item['Children']">
                                        {{child['TermsDescriptionOtherLanguage']}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
    <br><br>
            <!-- <div [ngClass]="{'hide_container' : termsCompleted}"> -->
                    <!-- <div class="sign-pad-wrapper" [ngClass]="{'hide_container' : showOtp}">
                        <div class="signature" style="width: 600px; height:400px;">
                            <div class="tool-bar">
    
                                <button pButton type="button" class="btn-general back-btn" (click)="clearSign()"
                                    label="{{translation['Clear']}}"></button>
                                <button pButton type="button" class="btn-general back-btn" (click)="invokeSignPad()"
                                    label="{{translation['SignPad']}}"></button>
                            </div>
    
                            <canvas [hidden]="signatureOnSignaturePad" #signPad class="vid" width="600" height="350"></canvas>
    
                            <div *ngIf="signatureOnSignaturePad" class="topaz">
                                <div *ngIf="!signatureSigned" class="empty-area-signpad"></div>
                                <img *ngIf="signatureSigned" src="{{signImageData}}" alt="">
                            </div>
                        </div>
                    </div> -->
    
                <!-- <ng-container *ngIf="showOtp">
                    <div class="p-grid">
                        <div class="input-group p-col-4">
                            <label for="">{{translation['EnterOTP']}} : </label>
                                <input class="cust-input" type="text" placeholder="{{translation['EnterOTP']}}" [(ngModel)]="otpNumber" (input)="checkValue()" pInputText />
                        </div>
                        <div class="input-group p-col-8 positionbtn">
                            <div class="cta">
                                <button [disabled]="validate()" pButton type="button" class="btn-general next-btn" (click)="sendOtp()"
                                    label="{{translation['SendOTP']}}"></button>
                                <span>
                                <button [disabled]="!showVerify" pButton type="button" class="btn-general next-btn" label="{{translation['Verify']}}" (click)="verifyOtp()"></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-container> -->
            <!-- </div>
    <br><br> -->
            </div>
        <!-- <div class="dialog-footer">
            <div class="cta" [ngClass]="{'hide_container' : termsCompleted}">
                <button pButton type="button" class="btn-general next-btn" (click)="submit()"
                     [disabled]="validate()" *ngIf="!showOtp"
                    label="{{translation['Submit']}}"></button>
            </div>
        </div> -->
    </div>